// extracted by mini-css-extract-plugin
export default {"prevBreadcrumb":"breadcrumbs_prevBreadcrumb__ZNoMO","currentBreadcrumb":"breadcrumbs_currentBreadcrumb__DbS2A","arrowImg":"breadcrumbs_arrowImg__DyXrH"};